registerComponent("blocks/card-home-insights", function (component) {

});
